import { BlockText, GridContainer, GridItem, ViewSection } from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";

const AccountVerificationViewSection = ({ record }) => {
  const { t } = useTranslation();

  return (
    <ViewSection label={"t.account.verification.details"}>
      <GridContainer spacing={3} mt={0}>
        <GridItem>
          <BlockText label={"l.user.enabled"} text={record.enabled ? t("l.yes") : t("l.no")} />
        </GridItem>
        <GridItem>
          <BlockText label={"l.user.emailVerified"} text={record.emailVerified ? t("l.yes") : t("l.no")} />
        </GridItem>
      </GridContainer>
    </ViewSection>
  );
};

export default AccountVerificationViewSection;
